module.exports = __webpack_public_path__ + "img/bulletedList_p.5ec810e5.svg";